module.exports = __webpack_public_path__ + "img/case-logo-13.36623807.png";